export function somaTotalDependentes(listaDependentes) {
    if (Array.isArray(listaDependentes)) {
        const Deptotal = listaDependentes.map(
            dependente => {
                if (dependente['Associado.Plano'].trim() === 'ZTA') {
                    return dependente.valor;
                }

                return dependente['CategoriaParentesco.Valor'];
            });

        return Deptotal.reduce(
            (valorAnterior, valorAtual) => valorAnterior + valorAtual,
            0
        );
    }
}
